// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3508":"d3525d00","7562":"6302e0c7","8607":"fee5ae8b","8765":"b1ab3892"}[chunkId] + ".chunk.css";
};